<div class="order-number">
  {{ 'orderDetail.orderNumber' | translate }}:
  <span class="order-id">{{ orderId }}</span>
</div>

